import { useSettings } from '@capsicum/common';
import { useAtomValue } from 'jotai';

import { v2MigrationTxHashAtom } from '../data-access';

type UseV2MigrationStatus = {
	ongoingMigrations: number;
};

export const useV2MigrationStatus = ({ ongoingMigrations }: UseV2MigrationStatus) => {
	const v2MigrationTxHash = useAtomValue(v2MigrationTxHashAtom);

	const {
		areSettingsLoading,
		settings: { fanTokenV2MigrationEnabled }
	} = useSettings();

	return {
		isLoading: areSettingsLoading,
		isMigrating: fanTokenV2MigrationEnabled && (ongoingMigrations > 0 || v2MigrationTxHash !== null)
	};
};
